import React from 'react';
import { formatMoney } from '../../util/currency';
import { LINE_ITEM_SETUP_FEE } from '../../util/types';

import css from './OrderBreakdown.module.css';

// LineItemSetupFeeMaybe — displays the on-site setup fee on the order
// breakdown.
//
// Looks for line-item code 'line-item/white-glove-fee' (the value of
// LINE_ITEM_SETUP_FEE). The string is intentionally still the legacy
// 'white-glove-fee' even though the user-facing concept renamed to
// 'setup' on 2026-05-13: transaction line items are immutable
// historical records, so a code rename would mean pre-rename
// transactions stop displaying their fee in the breakdown. We accept
// this one bounded naming drift — every other reference to the
// concept (listing publicData keys, fulfillment enum value, JS
// identifiers, UI labels) uses 'setup'. See src/util/types.js for
// the full rationale.
const LineItemSetupFeeMaybe = props => {
  const { lineItems, intl } = props;
  const item = lineItems.find(
    i => i.code === LINE_ITEM_SETUP_FEE && !i.reversal
  );

  if (!item) return null;

  const label = intl.formatMessage({ id: 'OrderBreakdown.setupFee' });
  const formattedTotal = formatMoney(intl, item.lineTotal);

  return (
    <div className={css.lineItem}>
      <span className={css.itemLabel}>{label}</span>
      <span className={css.itemValue}>{formattedTotal}</span>
    </div>
  );
};

export default LineItemSetupFeeMaybe;
